/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './TemplateManagementAppService';
import * as Queries from './TemplateManagementAppService.dfc.new';
import type { AdditionalContextArgs } from './TemplateManagementAppService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseListTemplateInstallsByGlobalIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListTemplateInstallsByGlobalIdResponseType>,
    References.ListTemplateInstallsByGlobalIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listTemplateInstallsByGlobalId',
            References.ListTemplateInstallsByGlobalIdResponseType
          >
        : References.ListTemplateInstallsByGlobalIdResponseType)
    | undefined;
};

export function useListTemplateInstallsByGlobalIdQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.ListTemplateInstallsByGlobalIdResponseType>,
    References.ListTemplateInstallsByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListTemplateInstallsByGlobalIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listTemplateInstallsByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListTemplateInstallsByGlobalIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListTemplateInstallsByGlobalIdQueryReturn<T>;
}

type UseListTemplateInstallsByGlobalIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListTemplateInstallsByGlobalIdResponseType>,
    References.ListTemplateInstallsByGlobalIdRequestType,
    T extends true
      ? Record<
          'listTemplateInstallsByGlobalId',
          References.ListTemplateInstallsByGlobalIdResponseType
        >
      : References.ListTemplateInstallsByGlobalIdResponseType
  >;

export function useListTemplateInstallsByGlobalIdLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListTemplateInstallsByGlobalIdResponseType>,
    References.ListTemplateInstallsByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListTemplateInstallsByGlobalIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listTemplateInstallsByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListTemplateInstallsByGlobalIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListTemplateInstallsByGlobalIdLazyQueryReturn<T>;
}

type UseListTemplateInstallsByGlobalIdSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.ListTemplateInstallsByGlobalIdResponseType>,
      References.ListTemplateInstallsByGlobalIdRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'listTemplateInstallsByGlobalId',
          References.ListTemplateInstallsByGlobalIdResponseType
        >
      : References.ListTemplateInstallsByGlobalIdResponseType;
  };

export function useListTemplateInstallsByGlobalIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListTemplateInstallsByGlobalIdResponseType>,
    References.ListTemplateInstallsByGlobalIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListTemplateInstallsByGlobalIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listTemplateInstallsByGlobalId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListTemplateInstallsByGlobalIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListTemplateInstallsByGlobalIdSuspenseQueryReturn<T>;
}
